import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meta: {
    pageNumber: 1,
    pageSize: 20,
    itemTotal: 0,
  },
  list: [],
  userDocuments: [],
  reportingToList: [],
  reportingToAdmins: [],
  selectedUser: {
    user: {
      _id: undefined,
    },
    files: [],
  },
  userAdded: false,
  userUpdated: false,
  userRemoved: false,
  emailResent: false,
  isFetched: false,
  leadAndCaseOwner: null
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    getUsers(state, action) {
      state.list = action.payload.Users;
      state.meta = action.payload.meta;
      state.isFetched = true;
    },
    getUserDocuments(state, action) {
      state.userDocuments = action.payload.files;
      state.meta = action.payload.meta;
    },
    getUsersById(state, action) {
      state.selectedUser = action.payload;
    },
    getLeadAndCaseOwner(state, action) {
      state.leadAndCaseOwner = action.payload;
    },
    addUsers(state, action) {
      state.userAdded = true;
    },
    updateUsers(state, action) {
      state.userUpdated = true;
    },
    removeUsers(state, action) {
      state.userRemoved = true;
    },
    emailResent(state, action) {
      state.emailResent = true;
    },
    getListOfReportingToUsers(state, action) {
      state.reportingToList = action.payload.Users;
    },
    getListOfReportingToAdmins(state, action) {
      state.reportingToAdmins = action.payload.Users;
    },
    clearReportingUser(state, action) {
      state.reportingToAdmins = [];
    },
    reset: (state) => initialState,
    logout: (state) => initialState,
  },
});

export const usersActions = usersSlice.actions;
export default usersSlice;
